export default __webpack_public_path__ + "static/media/logo-full.fa78c7ed.svg";